var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-embed-custom",style:('height:' + this. getHeight())},[_c('b-embed',{style:('height:' + this. getHeight()),attrs:{"type":"iframe","src":this.data,"allowfullscreen":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }